import React from 'react';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import IconButton from '@mui/material/IconButton';
import MediaQuery from '../../../../../CommonComponents/UseMediaQuery/MediaQueryComponent';
import ShoppingCartPaper from './ShoppingCartPaper';
import Badge from '@mui/material/Badge';
import Style from '../Styles/ShoppingCartButtonStyle'


export default function ShoppingCartButton(props) {
  const classes = Style();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const componentConstants = {
      ...props.componentConstants
  }

  const componentMethods = {
      ...props.componentMethods,
      handleClosePopover: () => {
        handleClose()
      }
  }

  const componentProps = {
      ...props.componentProps
  }
  
  return (<div ref={componentConstants.wrapperPopoverDiv}>
        <Badge badgeContent={componentMethods.getManagerState().shoppingCartTotal} color="primary">
          <MediaQuery 
                    lg={<Button variant="outlined"  onClick={handleClick} style={classes.button} color="secondary" component="span" startIcon={<ShoppingCartIcon />}>
                    {componentConstants.language.LANG_SHOPPING_CART}
                </Button>} 
                    sm={<IconButton aria-label="delete" style={classes.button}  onClick={handleClick}>
                    <ShoppingCartIcon color="secondary" />
                  </IconButton>} 
                    xs={<IconButton aria-label="delete" style={classes.button} onClick={handleClick}>
                    <ShoppingCartIcon color="secondary" />
                  </IconButton>} 
                    md={<IconButton aria-label="delete" style={classes.button}  onClick={handleClick}>
                    <ShoppingCartIcon color="secondary" />
                  </IconButton>} 
                    xl={<Button variant="outlined"   onClick={handleClick} style={classes.button} color="secondary" component="span" startIcon={<ShoppingCartIcon />}>
                    {componentConstants.language.LANG_SHOPPING_CART}
                </Button>}  />
          </Badge>
         <Popover
         id={id}
         open={open}
         anchorEl={anchorEl}
         onClose={handleClose}
         anchorOrigin={{
           vertical: 'bottom',
           horizontal: 'center',
         }}
         transformOrigin={{
           vertical: 'top',
           horizontal: 'center',
         }}
       >
         <ShoppingCartPaper componentMethods={componentMethods} componentConstants={componentConstants} componentProps={componentProps} />
       </Popover>
        </div>
  );
}